import { get } from 'lodash';
import {
  getBundleName,
  getLayoutTypePath,
  LAYOUT_SIDE_BY_SIDE,
  LAYOUT_FULL_POST,
  LAYOUT_ONE_COLUMN_MOBILE,
  LAYOUT_SIDE_BY_SIDE_MOBILE,
  LAYOUT_PG_GRID,
  isExperimentEnabled,
  SECTION_POST_LIST,
  SECTION_RELATED_POSTS,
  SECTION_MY_POSTS,
} from '@wix/communities-blog-client-common';
import { EXPERIMENT_DEFAULT_MOBILE_LAYOUT_SIDE_BY_SIDE } from '@wix/communities-blog-experiments';

import { getMyPostsLayoutType } from '../../my-posts-page/store/selectors/my-posts-layout-type';
import { POST_LIST_WIDGET_BUNDLE_NAME } from '../../post-list-widget/constants/post-list-widget';
import { getPostListLayoutType } from '../../post-list-widget/selectors/post-list-layout-type';
import { RELATED_POSTS_WIDGET_BUNDLE_NAME } from '../../related-posts-widget/constants/related-posts-widget';
import { getRelatedPostsLayoutType } from '../../related-posts-widget/selectors/related-posts-layout-type';
import {
  isSeo,
  getIsMobile,
  getIsDesktop,
} from '../store/basic-params/basic-params-selectors';
import { AppState } from '../types';
import { getAppSettings } from './app-settings-base-selectors';
import { getIsCreatedWithResponsiveEditor } from './app-settings-selectors';

import { getSection } from './section-selectors';

// use withLayoutProps HOC for app

export const getDefaultLayout = (state: AppState, isMobile: boolean) => {
  if (isMobile) {
    const isDefaultMobileLayoutSideBySideExperimentEnabled =
      isExperimentEnabled(state, EXPERIMENT_DEFAULT_MOBILE_LAYOUT_SIDE_BY_SIDE);

    return isDefaultMobileLayoutSideBySideExperimentEnabled
      ? LAYOUT_SIDE_BY_SIDE_MOBILE
      : LAYOUT_ONE_COLUMN_MOBILE;
  }

  if (
    getBundleName(state) === POST_LIST_WIDGET_BUNDLE_NAME ||
    getBundleName(state) === RELATED_POSTS_WIDGET_BUNDLE_NAME
  ) {
    return LAYOUT_PG_GRID;
  }

  const isCreatedWithResponsiveEditor = getIsCreatedWithResponsiveEditor(state);
  return isCreatedWithResponsiveEditor ? LAYOUT_PG_GRID : LAYOUT_SIDE_BY_SIDE;
};

export const getLayoutType = (
  state: AppState,
  section?: string,
  isMobile?: boolean,
) => {
  if (!section) {
    return undefined;
  }

  if (section === SECTION_POST_LIST) {
    return getPostListLayoutType({ state, isMobile });
  }

  if (section === SECTION_RELATED_POSTS) {
    return getRelatedPostsLayoutType({ state, isMobile });
  }

  if (section === SECTION_MY_POSTS) {
    return getMyPostsLayoutType(state);
  }

  isMobile = typeof isMobile !== 'undefined' ? isMobile : getIsMobile(state);
  const defaultLayout = getDefaultLayout(state, isMobile);
  return get(
    getAppSettings(state),
    getLayoutTypePath(section, isMobile),
    defaultLayout,
  );
};

export const isMasonryLayoutSupported = (state: AppState) => !isSeo(state);

export const isFullPostLayout = (state: AppState, section?: string) =>
  getLayoutType(state, section || getSection(state, true)) === LAYOUT_FULL_POST;

export const isPostContentRequired = (state: AppState, section?: string) =>
  getIsDesktop(state) && isFullPostLayout(state, section);

export const isExcludePostContentSupported = (
  state: AppState,
  section?: string,
) => !isPostContentRequired(state, section);
